export enum CommunityUpdateType {
  FEATURE_CONTENT = 1,
  BLOG_POST = 2,
}
